import React, { useEffect, useState } from "react";
import {
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Grid
} from "@mui/material";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import useAdminProfileUtils from "../../ProfilePlugin/utils/useAdminProfileUtils";
import { useProfile } from "../hooks/useProfile";
import ProfileService from "../service/api/profile";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CircularProgress, Stack } from '@mui/material';
import { useSnackbar } from "notistack";


const UpdateProfileStatusComponent = (props) => {
    const { open, setOpen, selectedProfile } = props;
    const {enqueueSnackbar} = useSnackbar();

    const {isFetchingProfileStatus, profileStatusList, getProfileStatusUtil} = useAdminProfileUtils();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false); // New state for confirmation dialog

    useEffect(() => {
        getProfileStatusUtil();
    }, []);

    const handleChange = (setter) => (event) => {
        setter(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleUpdateProfile = async () => {

        setIsSubmitting(true);

        const parameters = {
            profileUID: selectedProfile.profile_uid,
        };

        const payload = {
            status: selectedStatus,
        };

        try {
            const updateProfileResponse = await ProfileService.updateProfileStatus(parameters, payload);

            if(updateProfileResponse.success){
                setConfirmOpen(false); 
                setOpen(false);   
            }else{
                 setConfirmOpen(true); 
                 setOpen(true);   
            }
            
        } catch (error) {
            
            console.log("Update failed:", error);
            const errorMessage = error?.response?.data?.error_message || error.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
            setIsSubmitting(false);
        }
    };


    const handleOpenConfirm = () => {
        setConfirmOpen(true);
        // setOpen(true);
    };

    const handleCloseConfirm = () => {
        setConfirmOpen(false);
        // setOpen(false);
    };

    const actions = [
        {
            label: "Confirm",
            onClick: handleOpenConfirm,
        }
    ];

    return (
        <>
            {!confirmOpen && (
                <CustomDialog
                    open={open}
                    onClose={handleClose}
                    title="Update Status"
                    subtitle={"Update your profile status"}
                    hasDividers={true}
                    content={
                        <Box sx={{mt: 2}}>
                            
                            <FormControl fullWidth>
                                <InputLabel shrink sx={{ bgcolor: 'white' }}>Select Status</InputLabel>
                                <Select
                                    defaultValue={selectedProfile?.status || ""}
                                    onChange={handleChange(setSelectedStatus)}
                                >
                                    {profileStatusList.map((name) => (
                                        <MenuItem key={name} value={name}>
                                            {name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    }
                    actions={actions}
                    maxWidth={"sm"}
                />
            )}
            {/* Confirmation Dialog */}
            <Dialog open={confirmOpen} onClose={handleCloseConfirm} maxWidth="sm" fullWidth>
                <DialogContent dividers>
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }} >
                        <ListItem >
                            <ListItemAvatar>
                            {/* <Avatar> */}
                                <CheckCircleOutlineIcon color="primary" sx={{width: 80, height: 80, mr: 1}} />
                            {/* </Avatar> */}
                            </ListItemAvatar>
                            <ListItemText primary={<Typography sx={{fontSize: 18, fontWeight:'bold'}}>Confirm Update</Typography>} secondary="Are you sure you want to update this status? This action will apply the changes immediately." />
                        </ListItem>
                    </List>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleCloseConfirm}
                        // color="inherit"
                        variant="outlined"
                        size="medium"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleUpdateProfile}
                        color="primary"
                        variant="contained"
                        size="medium"
                        disabled={isSubmitting}
                        startIcon={isSubmitting && <CircularProgress color="inherit" size={20} />}
                    >
                        {isSubmitting ? "Updating..." : "Confirm"}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
};

export default UpdateProfileStatusComponent;
